import { style } from '@primeuix/styles/iftalabel';
import BaseStyle from '@primevue/core/base/style';

const classes = {
    root: 'p-iftalabel'
};

export default BaseStyle.extend({
    name: 'iftalabel',
    style,
    classes
});
